import { render } from "./HotelShowComponent.vue?vue&type=template&id=39bc5a54"
import script from "./HotelShowComponent.vue?vue&type=script&lang=js"
export * from "./HotelShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__